// Customer-portal calls. Every one is scoped on the server to the signed-in
// customer's own account (see backend/portal_routes.py and the customer read
// filter in server.py); nothing here passes a customer id.
import http from './api';

export const portalApi = {
  profile: () => http.get('/portal/profile').then((r) => r.data),
  updateProfile: (body) => http.put('/portal/profile', body).then((r) => r.data),
  request: (body) => http.post('/portal/requests', body).then((r) => r.data),
  documents: () => http.get('/portal/documents').then((r) => r.data),
  payments: () => http.get('/payments').then((r) => r.data),
};

export default portalApi;
